import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TokenContext from './TokenContext';

function Callback() {
  const { setToken } = useContext(TokenContext);
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      setToken(token);
      navigate('/banners');
    } 
  }, [setToken, navigate]);

  return (
    <div>
    </div>
  );
}

export default Callback;
